export const PageRoutes: any = {
  LAB_ADD: "/lab/add",
  LAB_EDIT: "/lab/edit",
  LAB_LIST: "/lab",

  // DASHBOARD: "/dashboard",

  USERS_ADD: "/users/add",
  USERS_EDIT: "/users/edit",
  USERS_LIST: "/users",

  EMPLOYEE_ADD: "/job-seakers/add",
  EMPLOYEE_EDIT: "/job-seakers/edit",
  EMPLOYEE_LIST: "/job-seakers",

  JOB_ADD: "/job/add",
  JOB_EDIT: "/job/edit",
  JOB_LIST: "/jobs",

  JOB_APPLICATION_ADD: "/job-application/add",
  JOB_APPLICATION_EDIT: "/job-application/edit",
  JOB_APPLICATION_LIST: "/job-applications",

  PHARMACIST_ADD: "/pharmacist/add",
  PHARMACIST_EDIT: "/pharmacist/edit",
  PHARMACIST_LIST: "/pharmacist",

  LAB_DIAGNOSIS_ADD: "/labdiagnosis/add",
  LAB_DIAGNOSIS_EDIT: "/labdiagnosis/edit",
  LAB_DIAGNOSIS_LIST: "/labdiagnosis",
  BLOG_ADD: "/blog/add",
  BLOG_EDIT: "/blog/edit",
  BLOG_LIST: "/blog",


  BOOKINGS_ADD: "/bookings/add",
  BOOKINGS_EDIT: "/bookings/edit",
  BOOKINGS_LIST: "/bookings",

  PRIVACYPOLICY_LIST:"/privacypolicy",
  PRIVACYPOLICY_ADD:"/privacypolicy/add",



  PATIENT_ADD: "/patient/add",
  PATIENT_EDIT: "/patient/edit",
  PATIENT_LIST: "/patients",

  MEDICINE_ADD: "/medicines/add",
  MEDICINE_EDIT: "/medicines/edit",
  MEDICINE_LIST: "/medicines",

  MEDICINE_DETAILS_ADD: "/medicine-details/add",
  MEDICINE_DETAILS_EDIT:"/medicine-details/edit",
  MEDICINE_DETAILS_LIST: "/medicine-details"
};


